var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMealIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ffbb00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6009 8.66797C21.5891 8.66797 23.2009 10.3237 23.2009 12.3662V17.5438C23.2009 17.8832 22.9761 18.179 22.6556 18.2613L20.3209 18.8609V22.7213C20.3209 23.1298 19.9985 23.461 19.6009 23.461C19.2032 23.461 18.8809 23.1298 18.8809 22.7213V9.40762C18.8809 8.99912 19.2032 8.66797 19.6009 8.66797ZM20.3209 17.3361L21.7609 16.9663V12.3662C21.7609 11.4001 21.1598 10.5781 20.3209 10.2735V17.3361Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2408 9.40762C10.2408 8.99912 9.91845 8.66797 9.52079 8.66797C9.12314 8.66797 8.80078 8.99912 8.80078 9.40762V12.3662C8.80078 14.1554 10.0376 15.6478 11.6808 15.9905V22.7213C11.6808 23.1298 12.0032 23.461 12.4008 23.461C12.7985 23.461 13.1209 23.1298 13.1209 22.7213V15.9905C14.7641 15.6478 16.0009 14.1554 16.0009 12.3662V9.40762C16.0009 8.99912 15.6786 8.66797 15.2809 8.66797C14.8833 8.66797 14.5609 8.99912 14.5609 9.40762V12.3662C14.5609 13.3324 13.9598 14.1543 13.1209 14.4589V9.40762C13.1209 8.99912 12.7985 8.66797 12.4008 8.66797C12.0032 8.66797 11.6808 8.99912 11.6808 9.40762V14.4589C10.8419 14.1543 10.2408 13.3324 10.2408 12.3662V9.40762Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealIcon);
export default __webpack_public_path__ + "static/media/meal-icon.67f64420111015eeb8ee7de85ac9ad2c.svg";
export { ForwardRef as ReactComponent };